module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-rqf-page mpsOrder",
    style: ({
      filter: (_vm.$route.name == 'request' && _vm.$root.ui.loading == 'getRequest') ? 'blur(6px)' : 'none'
    })
  }, [_c('div', {
    staticClass: "orderFeed"
  }, [_vm._l((_vm.feed.items), function(item, idx) {
    return [(item.type == 'comment' && !_vm.$root.isAdminPage()) ? [_c('div', {
      staticClass: "opqCommentDate",
      domProps: {
        "textContent": _vm._s(_vm.$root.formatDate(item.date, true, true))
      }
    }), _vm._v(" "), _c('div', {
      class: ['opqComment', item.content.id_owner ? 'admin' : 'client']
    }, [_c('div', {
      staticClass: "opqCommentText",
      domProps: {
        "innerHTML": _vm._s(item.content.text)
      }
    })])] : _vm._e(), _vm._v(" "), (item.type == 'offer') ? [_c('div', {
      staticClass: "currentOpqOffer"
    }, [
      [_c('h3', [_vm._v("Tilbud på oppretting av bilskader")]), _vm._v(" "), _c('table', {
        staticClass: "opqOffer"
      }, [_vm._m(0, true), _vm._v(" "), _c('tbody', [_vm._l((_vm.$root.damages), function(damage, idx) {
        return [_c('tr', {
          staticClass: "bt"
        }, [_c('td', [_c('b', {
          domProps: {
            "textContent": _vm._s(idx + 1 + '. ' + damage.type.join(', '))
          }
        }), _c('br')]), _vm._v(" "), (damage.offer_price) ? [_c('td', [_c('span', {
          domProps: {
            "textContent": _vm._s(damage.offer_price.toFixed(0))
          }
        })]), _vm._v(" "), _c('td', [_c('span', {
          domProps: {
            "textContent": _vm._s((damage.offer_price * 0.25).toFixed(0))
          }
        })]), _vm._v(" "), _c('td', [_c('span', {
          domProps: {
            "textContent": _vm._s((damage.offer_price * 1.25).toFixed(0))
          }
        }), _vm._v(" kr")])] : [_c('td', {
          attrs: {
            "colspan": "3"
          }
        })]], 2), _vm._v(" "), (damage.offer_discount) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Rabatt "), (_vm.$root.contact.is_naf_member && damage.offer_discount) ? _c('span', [_vm._v("NAF")]) : _vm._e(), _vm._v(" "), _c('span', {
          domProps: {
            "textContent": _vm._s(damage.offer_discount + '%')
          }
        })]), _vm._v(" "), _c('td', [_c('span', {
          domProps: {
            "textContent": _vm._s((-damage.offer_price * 1.25 * damage.offer_discount / 100).toFixed(0))
          }
        }), _vm._v(" kr")])]) : _vm._e(), _vm._v(" "), (damage.offer_text) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          },
          domProps: {
            "textContent": _vm._s(damage.offer_text)
          }
        })]) : _vm._e()]
      })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_c('span', {
        domProps: {
          "textContent": _vm._s((item.totalPrice + item.rentalPrice).toFixed(0))
        }
      })]), _vm._v(" "), _c('td', [_c('span', {
        domProps: {
          "textContent": _vm._s(((item.totalPrice + item.rentalPrice) * item.tax).toFixed(0))
        }
      })]), _vm._v(" "), _c('td', [_c('span', {
        domProps: {
          "textContent": _vm._s(((item.totalPrice + item.rentalPrice) * (1 + item.tax)).toFixed(0))
        }
      }), _vm._v(" kr")])]), _vm._v(" "), _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "3"
        }
      }, [_c('b', [_c('span', {
        domProps: {
          "textContent": _vm._s(((item.totalPrice + item.rentalPrice) * (1 + item.tax)).toFixed(0))
        }
      }), _vm._v(" kr")])])])])]), _vm._v(" "), (_vm.isAdminRoute()) ? _c('button', {
        staticClass: "button primary",
        attrs: {
          "disabled": _vm.$root.ui.loading
        },
        on: {
          "click": _vm.editOffer
        }
      }, [_vm._v("Redigere")]) : _vm._e()], _vm._v(" "), (!parseInt(_vm.$root.request.offer_status) && _vm.isClientRoute()) ? void 0 : _vm._e(), _vm._v(" "), (_vm.$root.isAdminPage()) ? _c('div', {
        staticClass: "opqOfferActions"
      }, [_c('button', {
        staticClass: "button primary",
        attrs: {
          "disabled": _vm.$root.ui.loading
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.$root.newRequest.apply(null, arguments)
          }
        }
      }, [_vm._v("Ny prisforespørsel")])]) : _vm._e()
    ], 2)] : _vm._e()]
  }), _vm._v(" "), (_vm.$route.params.code && _vm.$root.isActiveOfferService() && !_vm.$root.isAdminPage() && !_vm.$root.isAddedByWorkshop()) ? _c('div', {
    class: ['opqComment', _vm.$route.params.type]
  }, [_c('div', {
    staticClass: "opqCommentText"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment),
      expression: "newComment"
    }],
    staticClass: "opqCommentField",
    attrs: {
      "rows": "4",
      "placeholder": "Skriv inn spørsmål eller kommentar til tilbudet"
    },
    domProps: {
      "value": (_vm.newComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.$root.validate && !_vm.newComment) ? _c('span', {
    staticClass: "v-error"
  }, [_vm._v("Comment is required")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "button primary",
    attrs: {
      "disabled": _vm.$root.ui.loading,
      "id": "js-add-comment"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendComment.apply(null, arguments)
      }
    }
  }, [_vm._v("Send")])])])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "damages-wrap"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$root.isAdminPage() ? 'Taksering av skade' : 'Oppsumering av din forespørsel'))]), _vm._v(" "), (_vm.$root.fleetCompany) ? _c('div', {
    staticClass: "partner-logo left"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.fleetCompany.logo
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    domProps: {
      "textContent": _vm._s(_vm.$root.contact.name)
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "result-list"
  }, [(_vm.$root.request.car_id) ? _c('div', [_c('dt', [_vm._v("Reg.nr:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.request.car_id)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$root.car.model) ? _c('div', [_c('dt', [_vm._v("Bil:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.car.producer + ' ' + _vm.$root.car.model)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Mobil:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.contact.phone)
    }
  })]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("E-post:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.request.ext_recipient_email ? _vm.$root.request.ext_recipient_email : _vm.$root.contact.email)
    }
  })]), _vm._v(" "), (_vm.$root.request.ext_ref) ? _c('div', [_c('dt', [_vm._v("Referanse:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.request.ext_ref)
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.$root.workshop) ? [_c('h4', [_vm._v("Verksted")]), _vm._v(" "), _c('dl', {
    staticClass: "result-list"
  }, [_c('div', [_c('dt', {
    domProps: {
      "textContent": _vm._s(_vm.$root.workshop.name)
    }
  }, [_vm._v("Lambertseter")])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Mobil:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.workshop.phone)
    }
  })]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("E-post:")]), _vm._v(" "), _c('dd', {
    domProps: {
      "textContent": _vm._s(_vm.$root.workshop.email)
    }
  })])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "damages-form"
  }, [_c('div', {
    staticClass: "damage"
  }, [_vm._l((_vm.$root.damages), function(damage, damageIndex) {
    return [_c('div', {
      staticClass: "preview-wrap"
    }, [_c('ul', {
      staticClass: "preview"
    }, _vm._l((damage.images), function(fileId, index) {
      return _c('li', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": _vm.$root.files[fileId].url
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.$root.files[fileId].url,
          "alt": 'Skade ' + (index + 1)
        }
      })])])
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "marker-num",
      domProps: {
        "textContent": _vm._s(damageIndex + 1)
      }
    })]), _vm._v(" "), (damage.description) ? _c('div', {
      staticClass: "description",
      domProps: {
        "textContent": _vm._s(damage.description)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$root.offerFormIsNeeded()) ? _c('div', {
      staticClass: "opqDamageOffer"
    }, [_c('v-select', {
      attrs: {
        "placeholder": "Velg type skade",
        "multiple": "",
        "options": _vm.$root.damageTypes
      },
      model: {
        value: (damage.type),
        callback: function($$v) {
          _vm.$set(damage, "type", $$v)
        },
        expression: "damage.type"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "textSelector"
    }, [_c('v-select', {
      staticClass: "opqOfferText",
      attrs: {
        "on-change": function(val) {
          _vm.$root.autoReplyChange(val, damage);
        },
        "placeholder": "Merknad",
        "options": _vm.$root.damageOfferTexts
      },
      model: {
        value: (damage.offer_text),
        callback: function($$v) {
          _vm.$set(damage, "offer_text", $$v)
        },
        expression: "damage.offer_text"
      }
    }), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (damage.offer_text),
        expression: "damage.offer_text"
      }],
      staticClass: "opqOfferComment",
      attrs: {
        "placeholder": "Merknad",
        "rows": "4"
      },
      domProps: {
        "value": (damage.offer_text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(damage, "offer_text", $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (damage.offer_price),
        expression: "damage.offer_price"
      }],
      staticClass: "opqDamagePrice",
      attrs: {
        "type": "number",
        "placeholder": "Pris eks mva"
      },
      domProps: {
        "value": (damage.offer_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(damage, "offer_price", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (damage.offer_discount),
        expression: "damage.offer_discount"
      }],
      staticClass: "opqDamageDiscount",
      attrs: {
        "type": "number",
        "placeholder": "Rabatt %"
      },
      domProps: {
        "value": (damage.offer_discount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(damage, "offer_discount", $event.target.value)
        }
      }
    }), _vm._v(" "), (damage.offer_discount_reason) ? _c('label', {
      staticStyle: {
        "font-size": "13px",
        "float": "right"
      }
    }, [_vm._v(_vm._s(damage.offer_discount_reason))]) : _vm._e()])], 1) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "model",
    attrs: {
      "id": "car-model"
    }
  }, [_c('div', {
    staticClass: "model-inner"
  }, [_c('img', {
    attrs: {
      "src": "/wp-content/plugins/autotaksering/requests/assets/img/tesla-model-s.png",
      "alt": "Model"
    }
  }), _vm._v(" "), _vm._l((_vm.$root.damages), function(damage, index) {
    return [(damage.position) ? _c('div', {
      staticClass: "marker",
      style: ('top:' + damage.position.top + '%;left:' + damage.position.left + '%;'),
      domProps: {
        "textContent": _vm._s(index + 1)
      }
    }) : _vm._e()]
  })], 2)])], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "opqOfferActions left"
  }, [(_vm.$root.isAdminUser()) ? _c('button', {
    staticClass: "button primary",
    attrs: {
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportToXbulk.apply(null, arguments)
      }
    }
  }, [_vm._v("Send til Xbulk")]) : _vm._e(), _vm._v(" "), (_vm.isAdminRoute() && !_vm.$root.isRequestFinished() && _vm.$root.isOfferConsidered()) ? _c('button', {
    staticClass: "button primary",
    attrs: {
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setAsFinished.apply(null, arguments)
      }
    }
  }, [_vm._v("Merk som ferdig")]) : _vm._e(), _vm._v(" "), (_vm.isAdminRoute()) ? _c('button', {
    staticClass: "button primary",
    attrs: {
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.newRequest.apply(null, arguments)
      }
    }
  }, [_vm._v("Ny prisforespørsel")]) : _vm._e(), _vm._v(" "), (_vm.isAdminRoute() && _vm.$root.isAdminUser()) ? _c('div', [_c('button', {
    staticClass: "button pink",
    attrs: {
      "disabled": _vm.$root.ui.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setAsContacted.apply(null, arguments)
      }
    }
  }, [_vm._v("Kunde kontaktet")]), _vm._v(" "), (_vm.$root.request.contact_date) ? _c('p', {
    staticClass: "mpsBtnDesc",
    domProps: {
      "textContent": _vm._s(_vm.$root.customDateFormat(_vm.$root.request.contact_date))
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Beskrivelse")]), _vm._v(" "), _c('th', [_vm._v("Beløp"), _c('br'), _vm._v(" (eks. mva)")]), _vm._v(" "), _c('th', [_vm._v("Mva"), _c('br'), _vm._v(" (25%)")]), _vm._v(" "), _c('th', [_vm._v("Beløp"), _c('br'), _vm._v(" (inkl. mva)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Sum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Tilbud")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e30e8c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Finish.vue
// module id = 114
// module chunks = 0